
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";

import authReducer from '../reducers/authReducer';

const ReduxStore = ({ children }) => {
    /* Combine all reducers */
    const persistConfig = { key: "auth", storage, version: 1 };
    const persistedReducer = persistReducer(persistConfig, authReducer);
    
    const rootReducer = combineReducers({
        auth: persistedReducer, // only authReducer is persisted
        //nav: navReducer,
    });

    /* Create the store */
    const store = configureStore({
        reducer: rootReducer, //persistedReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }),
    });

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistStore(store)}>
                {children}
            </PersistGate>
        </Provider>
    );
};

export default ReduxStore;

